<template>
  <div class="basicInfo">
    <div class="title">
      <h2>基本信息</h2>
    </div>
    <div class="man">
      <div class="tit">
        <h2>个人信息</h2>
      </div>
      <div class="box">
        <div class="left">
          <p><span>用户名：</span>{{ list.name }}</p>
          <p><span>账号：</span>{{ list.account }}</p>
          <div class="telp">
            <span>联系方式：</span>
            <span v-if="list.telephone">{{ list.telephone }}</span>
            <template v-else>
              <span>未绑定</span>
              <span @click="bindphone">绑定</span>
            </template>
          </div>
          <div class="ress">
            <span>联系地址：</span>
            <span v-if="list.address">{{ list.address }} </span>
            <span v-else>未填写</span>
            <span @click="changeadd">修改</span>
          </div>
          <div class="addinp" v-if="addressshow">
            <eAddress @changeAddress="changeAddress"></eAddress>
            <button class="adsbtn" @click="addsure">确定</button>
          </div>
          <p>
            <span v-if="role == '企业人员'">所在单位：</span>
            <span v-else>所在学校：</span>
            {{ list.instituteName }}
          </p>
          <p class="maj">
            <span>所属专业：</span>
            <template>
              <span v-if="list.major">{{ list.major }}</span>
              <span v-else>未填写</span>
            </template>
            <span class="majspan" @click="changemaj">修改</span>
            <input
              v-if="majshow"
              class="majshow"
              type="text"
              v-model="major"
              placeholder="请输入专业"
            /><button v-if="majshow" class="majbtn" @click="majbtn">
              确定
            </button>
          </p>
          <div class="job" v-if="role == '教师'">
            <span>职称：</span>
            <span class="jobspan" v-if="list.proTitle">{{
              list.proTitle
            }}</span>
            <span class="jobspan" v-else>未填写</span>
            <span class="changejob" @click="changejob">修改</span>
            <div class="mod" v-show="jobshow">
              <a-select
                class="selbtn"
                allow-clear
                placeholder="请选择职称"
                :notFoundContent="'暂无数据'"
                @change="changejobmodel"
                v-decorator="[
                  'modelname',
                  { rules: [{ required: true, message: '请选择所属模块' }] },
                ]"
              >
                <a-select-option
                  v-for="(item, index) in navlist"
                  :key="index"
                  :value="item.jobtitle"
                >
                  {{ item.jobtitle }}
                </a-select-option>
              </a-select>
              <button class="jobbtn" @click="jobbtn">确定</button>
            </div>
          </div>
          <div class="job" v-else-if="role == '企业人员'">
            <span>职称：</span>
            <span class="jobspan" v-if="list.proTitle">{{
              list.proTitle
            }}</span>
            <span class="jobspan" v-else>未填写</span>
            <span class="changejob" @click="changejob">修改</span>
            <div class="mod" v-show="jobshow">
              <a-select
                class="selbtn"
                allow-clear
                placeholder="请选择职称"
                :notFoundContent="'暂无数据'"
                @change="indexSelect"
                v-decorator="[
                  'modelname',
                  { rules: [{ required: true, message: '请选择所属模块' }] },
                ]"
              >
                <a-select-option
                  v-for="(item, index) in biglist"
                  :key="index"
                  :value="item.jobtitle"
                >
                  {{ item.jobtitle }}
                </a-select-option>
              </a-select>
              <button class="jobbtn" @click="jobbtn">确定</button>
            </div>
          </div>
          <p class="apply">
            <span>会员权限：</span>
            <span>{{ list.authentation }}</span>

            <template v-if="list.authentation == '注册用户'">
             
              <button
                class="applyper not"
                v-if="membershipApply == 1 && applystatus == 0"
              >
                审核中
              </button>
              <button
                class="applyper"
                 @click="applyper()"
                v-else-if="membershipApply == 1 && applystatus == 2"
              >
                已拒绝，重新申请
              </button>
               <button
                class="applyper"
                @click="applyper()"
                v-else
              >
                申请普通会员
              </button>
            </template>
            <button v-else class="applyper not">申请普通会员</button>

            <template
              v-if="
                list.authentation == '注册用户' ||
                list.authentation == '普通会员'
              "
            >
              <button class="applyvip notbox" v-if="membershipApply ==2&&applystatus ==0">
                审核中
              </button>
              <button class="applyvip"  @click="applyvip()"  v-else-if="membershipApply ==2&&applystatus ==2">
                已拒绝，重新申请
              </button>
              <button class="applyvip" @click="applyvip()"  v-else >申请VIP会员</button>
            </template>
            <button v-else class="applyvip notbox">申请VIP会员</button>
          </p>
          <p v-if="list.authentation != '注册用户'" class="purview">
            <span>到期时间：</span>
            <span v-if="list.vipTime">{{ list.vipTime }}</span>
            <span v-else>无</span>
          </p>
          <p class="purview" v-if="role == '教师' || role == '企业人员'">
            <span>头衔：</span>
            <span v-if="list.title">{{ list.title }}</span>
            <span v-else>无</span>
          </p>
          <div class="pic">
            <div class="pictitle">证书头像：</div>
            <eCropper
              class="loadpic"
              v-if="resUrl"
              :recUrl="resUrl"
              @imgfile="imgfile"
            ></eCropper>
          </div>
        </div>
        <div class="right">
          <div class="pho">
            <eUpload
              :imageUrl="imageUrl"
              class="loadpho"
              @getUrl="getUrl"
            ></eUpload>
            <p>修改头像</p>
          </div>
        </div>
      </div>
    </div>
    <div class="real">
      <div class="tit">
        <h2>实名认证</h2>
        <button v-if="list.idCardNum" class="realbtn" type="primary">
          已实名认证
        </button>
        <button v-else class="realbtn" type="primary" @click="showModal()">
          申请实名认证
        </button>
      </div>
      <div class="realbox">
        <p><span>真实姓名：</span>{{ list.realname }}</p>
        <p><span>性别：</span>{{ list.gender }}</p>
        <p><span>身份证号：</span>{{ list.idCardNum }}</p>
        <p><span>所属单位：</span>{{ list.instituteName }}</p>
      </div>
    </div>
    <!-- <div class="expert" v-if="role=='教师'||role=='企业人员'">
      <div class="tit">
        <h2>专家申请</h2>
      </div>
      <div class="box">
        <button v-if="isexpert==null||isexpert==0||isexpert==2" class="expertbtn" @click="exbtn">专家申请</button>
        <button v-if="isexpert==1" class="expertbtn">已申请</button>
        <p>
          <span>申请状态：</span>
          <span v-if="isexpert==null" >未申请</span>
          <span v-else-if="isexpert==0" style="	color: #ee9537;">待审核</span>
          <span v-else-if="isexpert==1" style="color: #49af4f;">已通过</span>
          <span v-else style='color: #ff0000;'>未通过</span>
        </p>
      </div>
    </div> -->
    <div class="safe">
      <div class="tit">
        <h2>账号安全</h2>
      </div>
      <div class="box">
        <p>
          <span>密码修改：</span><span>********</span
          ><span @click="changepwd">修改密码</span>
        </p>
        <p>
          <span>邮箱修改：</span>
          <span v-if="list.email">{{ list.email }}</span>
          <span v-else>未填写</span>
          <span v-if="list.email" class="eamilbtn" @click="recEmail(list.email)"
            >修改绑定邮箱
          </span>
          <span v-else class="eamilbtn" @click="changeEmail">绑定邮箱 </span>
        </p>
      </div>
    </div>
    <a-modal
      class="applymodal"
      :title="applytype == 1 ? '普通会员申请' : 'VIP会员申请'"
      :visible="applyboxshow"
      @ok="applyok"
      @cancel="applycancel"
      okText="提交"
      cancelText="取消"
    >
      <div class="applybox">
        <p>
          <span>申请会员类型：</span>
          <span v-if="this.applytype == 1" style="color: #ef9545"
            >普通会员</span
          >
          <span v-else style="color: #ef9545">VIP会员</span>
          <span @click="watchbenefits">查看会员权益</span>
        </p>
        <p>
          <span>用户名：</span><span>{{ list.name }}</span>
        </p>
        <p>
          <span>账号：</span><span>{{ list.account }}</span>
        </p>
        <p>
          <span>真实姓名：</span><span>{{ list.realname }}</span>
        </p>
        <p>
          <span>身份证号码：</span><span>{{ list.idCardNum }}</span>
        </p>
        <p>
          <span>联系方式：</span><span>{{ list.telephone }}</span>
        </p>
        <p>
          <span>所在单位：</span><span>{{ list.instituteName }}</span>
        </p>
        <div class="info">
          <span><em style="color: red">*</em>申请理由：</span>
          <textarea v-model="info"></textarea>
        </div>
      </div>
    </a-modal>
    <a-modal
      class="benefitsmodal"
      :title="applytype == 1 ? '普通会员权益' : 'VIP会员权益'"
      :visible="benefitsshow"
      @ok="benefitsok"
      @cancel="benefitscancel"
      :footer="null"
      okText="提交"
      cancelText="取消"
    >
      <ul class="benefbox" v-if="applytype == 1">
        <li>支持学习全站普通会员权限课程所有内容</li>
        <li>支持学习全站普通会员权限题库训练内容</li>
      </ul>
      <ul class="benefbox" v-if="applytype == 2">
        <li>支持学习全站课程所有内容,含VIP权限和普通会员权限课程</li>
        <li>支持学习全站所有题库训练内容,含VIP权限和普通会员权限课程</li>
        <li v-if="role == '教师'">
          支持教师用户创建班级,赋予学生课程学习权限,查看学生学习情况
        </li>
      </ul>
    </a-modal>
    <a-modal
      title="绑定联系方式"
      :visible="phoneshow"
      @ok="phoneOk"
      @cancel="phonecancel"
      okText="绑定"
      cancelText="取消"
      class="phonemodal"
    >
      <div class="formbox">
        <eform :formData="formtel" class="form" ref="form">
          <div slot="binphone">
            <a-input
              v-decorator="[
                'binphone',
                {
                  rules: [
                    { required: true, message: ' ' },
                    { validator: validatorphone },
                  ],
                },
              ]"
              class="input"
              placeholder="请输入联系方式"
            />
          </div>
          <div slot="bincode" class="iteminp">
            <a-input
              class="cadeinp"
              v-decorator="[
                'bincode',
                {
                  rules: [
                    { required: true, message: ' ' },
                    { validator: validatorcaptcha },
                  ],
                },
              ]"
              placeholder="请输入短信验证码"
            />
            <a-button v-if="show" class="subbtn" @click="gocade">
              <span>获取验证码</span>
            </a-button>
            <a-button v-if="!show" class="subbtn">
              <span class="count">{{ count }}s</span>
            </a-button>
          </div>
        </eform>
      </div>
    </a-modal>
    <a-modal
      title="实名认证"
      :visible="confirmModal"
      @ok="handleOk"
      @cancel="cancel"
      okText="确认"
      cancelText="取消"
      class="realmodal"
    >
      <eform :formData="formData" class="formreal" ref="form">
        <div slot="name">
          <a-input
            v-decorator="[
              'name',
              {
                rules: [
                  { required: true, message: ' 请输入真实姓名' },
                  { validator: validatorName },
                ],
              },
            ]"
            class="input"
          />
        </div>
        <div slot="gender">
          <a-radio-group
            v-decorator="[
              'gender',
              { rules: [{ required: true, message: '请输入性别' }] },
            ]"
          >
            <a-radio :value="1"> 男 </a-radio>
            <a-radio :value="2"> 女 </a-radio>
          </a-radio-group>
        </div>
        <div slot="idnum">
          <a-input
            v-decorator="[
              'idnum',
              {
                rules: [
                  { required: true, message: '请输入合法身份证' },
                  { validator: validatorIdnum },
                ],
              },
            ]"
            class="input"
          />
        </div>
        <div slot="address">
          <a-input
            v-decorator="[
              'address',
              { rules: [{ required: true, message: '请输入所属单位' }] },
            ]"
            class="input"
          />
        </div>
      </eform>
      <div class="imp" style="color: red; margin-left: 50px">
        注意：
        <p style="margin-bottom: 10px; width: 350px">
          1.实名认证信息与考试报名、培训报名以及证书信息关联，请填写真实信息
        </p>
        <p>2.提交后的信息不支持修改、请认真填写</p>
      </div>
    </a-modal>
    <a-modal
      title="专家申请"
      :visible="expertshow"
      @ok="expertshowOk"
      @cancel="expertcancel"
      okText="提交"
      cancelText="取消"
      class="expertmodal"
    >
      <div class="box">
        <p>基本信息</p>
        <table>
          <tr>
            <td>姓名</td>
            <td>{{ list.realname }}</td>
            <td>性别</td>
            <td>{{ list.gender }}</td>
          </tr>
          <tr>
            <td>账号</td>
            <td>{{ list.account }}</td>
            <td>身份证号码</td>
            <td>{{ list.idCardNum }}</td>
          </tr>
          <tr>
            <td>手机号</td>
            <td>{{ list.telephone }}</td>
            <td>所属单位</td>
            <td>{{ list.instituteName }}</td>
          </tr>
          <tr>
            <td>地址</td>
            <td colspan="3">{{ list.address }}</td>
          </tr>
        </table>
        <!-- <div class="con">
            <p><span>*</span>申请内容:</p>
            <textarea type="text" placeholder="请填写输入内容"/>
          </div>
            <p class="material"><span>*</span>申请材料： <button class="dwloadbtn">选择文件</button></p> -->
        <eform action="" :formData="formfile" class="under" ref="form">
          <div slot="content" class="conbox">
            <a-textarea
              class="applycon"
              placeholder="请填写申请内容"
              v-decorator="[
                'content',
                {
                  rules: [
                    { required: true, message: '请输入申请内容' },
                    { validator: validatorContent },
                  ],
                },
              ]"
            >
            </a-textarea>
          </div>
          <div slot="file" class="pro">
            <a-upload
              v-decorator="[
                'file',
                {
                  rules: [
                    { required: true, message: '请上传文件' },
                    { validator: validateFile },
                  ],
                },
              ]"
              :file-list="fileList"
              :remove="handleRemove"
              :before-upload="beforeUpload"
              :multiple="false"
              accept=".pdf,.doc,.docx,.ppt,.xls,.xlsx"
            >
              <button class="loadbtn">文件上传</button>
            </a-upload>
          </div>
        </eform>
      </div>
    </a-modal>
    <a-modal
      title="密码设置"
      :visible="pwdshow"
      @ok="pwdOk"
      @cancel="pwdcancel()"
      okText="确认"
      cancelText="取消"
      class="pwdmodal"
    >
      <eform :formData="formPwd" class="form" ref="pwdform">
        <div slot="pwd">
          <a-input
            type="password"
            v-decorator="[
              'pwd',
              {
                rules: [
                  { required: true, message: '请输入旧密码' },
                  { validator: validatorpwd },
                ],
              },
            ]"
            class="input"
          />
        </div>
        <div slot="newpwd">
          <a-input
            type="password"
            v-decorator="[
              'newpwd',
              {
                rules: [
                  { required: true, message: '请输入新密码' },
                  { validator: validatornewpwd },
                ],
              },
            ]"
            class="input"
          />
        </div>
        <div slot="renewpwd">
          <a-input
            type="password"
            v-decorator="[
              'renewpwd',
              {
                rules: [
                  { required: true, message: '请确认新密码' },
                  { validator: validatorrenewpwd },
                ],
              },
            ]"
            class="input"
          />
        </div>
      </eform>
    </a-modal>
    <a-modal
      title="绑定邮箱"
      :visible="emailshow"
      @ok="emailOk"
      @cancel="emailcancel()"
      okText="确认"
      cancelText="取消"
      class="emailmodal"
      :destroyOnClose="true"
    >
      <eform :formData="formEmail" :fields="fields" class="form" ref="emailform">
        <div slot="email">
          <a-input
            v-decorator="[
              'email',
              {
                rules: [
                  { required: true, message: ' ' },
                  { validator: validatoremail },
                ],
              },
            ]"
            class="input"
          />
        </div>
        <div slot="reemail">
          <a-input
            v-decorator="[
              'reemail',
              {
                rules: [
                  { required: true, message: ' ' },
                  { validator: validatorreemail },
                ],
              },
            ]"
            class="input"
          />
        </div>
      </eform>
    </a-modal>
  </div>
</template>

<script>
// import { VueCropper }  from 'vue-cropper'
import {
  getmyInfo,
  getupdateInfo,
  bingphomeApi,
  checkExpertAppliedApi,
  getupdatepwd,
  checkPhoneApi,
  getcodeApi,
  expertApplyApi,
  getcommitMembershipApplyApi,
} from "@/request/api";
import eUpload from "@/components/common/eUpload";
import eform from "@/components/common/form";
import eAddress from "@/components/common/eAddress";
import eCropper from "@/components/common/eCropper";
export default {
  name: "basicInfo",
  components: { eUpload, eAddress, eform, eCropper },
  data() {
    const formfile = [
      {
        label: "申请内容",
        scopedSlots: { customRender: "content" },
      },
      {
        label: "申请材料",
        scopedSlots: { customRender: "file" },
      },
    ];
    let validatorContent = (rule, value, callback) => {
      if (value) {
        let reg = /^[\s\S]*/;
        if (value == "" || reg.test(value)) {
          this.content = value;
          callback();
        } else {
          callback(new Error("请输入汉字、英文字母和数字"));
        }
      } else {
        callback(new Error(" "));
      }
    };
    let validateFile = (rule, value, callback) => {
      if (value) {
        const isJpgOrPng =
          value.file.type === "application/pdf" ||
          value.file.type === "application/msword" ||
          value.file.type ===
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
          value.file.type === "application/vnd.ms-powerpoint" ||
          value.file.type === "application/vnd.ms-excel" ||
          value.file.type ===
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        // console.log(value.file.type)
        if (!isJpgOrPng) {
          callback(new Error("你只能上传pdf/doc/docx/ppt/xls/xlsx!"));
        } else {
          // console.log('123')
          callback();
        }
      } else {
        callback(new Error(" "));
      }
    };

    const formtel = [
      {
        label: "联系方式",
        scopedSlots: { customRender: "binphone" },
      },
      {
        label: "验证码",
        scopedSlots: { customRender: "bincode" },
      },
    ];
    let validatorphone = (rule, value, callback) => {
      var regphone = /^1[3456789]\d{9}$/;
      if (regphone.test(value)) {
        this.phone = value;
        callback();
      } else {
        callback(new Error("请输入正确格式的手机号"));
      }
    };
    let validatorcaptcha = (rule, value, callback) => {
      if (value == "" || value.trim()) {
        this.captcha = value;
        callback();
      } else {
        callback(new Error("请输入验证码"));
      }
    };
    const formData = [
      {
        label: "真实姓名",
        scopedSlots: { customRender: "name" },
      },
      {
        label: "性别",
        scopedSlots: { customRender: "gender" },
      },
      {
        label: "身份证号",
        scopedSlots: { customRender: "idnum" },
      },
      {
        label: "所在单位",
        scopedSlots: { customRender: "address" },
      },
    ];
    let validatorName = (rule, value, callback) => {
      let reg = /^[\u4e00-\u9fa5]/;
      if (value == "" || reg.test(value)) {
        callback();
      } else {
        callback(new Error("请输入真实姓名"));
      }
    };
    let validatorIdnum = (rule, value, callback) => {
      let reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      if (value == "" || reg.test(value)) {
        callback();
      } else {
        callback(new Error("请输入合法身份证"));
      }
    };
    const formPwd = [
      {
        label: "当前密码",
        scopedSlots: { customRender: "pwd" },
      },
      {
        label: "新密码",
        scopedSlots: { customRender: "newpwd" },
        type: "password",
      },
      {
        label: "确认新密码",
        scopedSlots: { customRender: "renewpwd" },
        type: "password",
      },
    ];
    let validatorpwd = (rule, value, callback) => {
      let reg = /^[\w$]{8,16}$/;
      if (value == "" || reg.test(value)) {
        callback();
      } else {
        callback(new Error("请输入8到16位合法密码"));
      }
    };
    let validatornewpwd = (rule, value, callback) => {
      let reg = /^[\w$]{8,16}$/;
      if (value == "" || reg.test(value)) {
        this.newpwd = value;
        callback();
      } else {
        callback(new Error("请输入8到16位合法密码"));
      }
    };
    let validatorrenewpwd = (rule, value, callback) => {
      this.renewpwd = value;
      if (value == "" || value == this.newpwd) {
        callback();
      } else {
        callback(new Error("两次密码不一致"));
      }
    };
    const formEmail = [
      {
        label: "输入邮箱",
        scopedSlots: { customRender: "email" },
      },
      {
        label: "确定邮箱",
        scopedSlots: { customRender: "reemail" },
      },
    ];
    let validatoremail = (rule, value, callback) => {
      let reg = /^[\w]\w{0,20}@(qq.com|126.com|163.com|QQ.com)$/;
      if (value == "" || reg.test(value)) {
        this.email = value;
        callback();
      } else {
        callback(new Error("请输入合法邮箱"));
      }
    };
    let validatorreemail = (rule, value, callback) => {
      if (value==""||value == this.email) {
        callback();
      } else {
        callback(new Error("邮箱不一致"));
      }
    };
    return {
      list: [],
      form: this.$form.createForm(this, { name: "horizontal_login" }),
      fields: null,
      validatorContent,
      validateFile,
      fileList: [],
      formfile,
      loading: false,
      // imageUrl: require("../../assets/mine/touxiang.png"),
      // resUrl: require("../../assets/mine/touxiang.jpg"),
      imageUrl: "",
      resUrl: "",
      addressshow: false,
      teladdress: "",
      majshow: false,
      major: "",
      confirmModal: false,
      formData,
      formtel,
      validatorName,
      validatorIdnum,
      validatorphone,
      sex: "",
      pwdshow: false,
      expertshow: false,
      formPwd,
      validatorpwd,
      validatornewpwd,
      validatorrenewpwd,
      newpwd: "",
      renewpwd: "",
      emailshow: false,
      formEmail,
      validatoremail,
      validatorreemail,
      email: "",
      navlist: [
        { jobtitle: "教授" },
        { jobtitle: "副教授" },
        { jobtitle: "讲师" },
        { jobtitle: "助教" },
      ],
      biglist: [
        { jobtitle: "初级" },
        { jobtitle: "中级" },
        { jobtitle: "高级" },
      ],
      jobshow: false,
      jobmenu: "",
      province: "",
      city: "",
      district: "",
      phoneshow: false,
      applyboxshow: false,
      count: "",
      timer: null,
      show: true,
      validatorcaptcha,
      phone: "",
      captcha: "",
      isexpert: "",
      expertisExist: "",
      benefitsshow: false,
      applytype: 1,
      reason: "",
      info: "",
      membershipApply: "",
      applystatus: "",
    };
  },
  created() {
    this.init();
  },
  computed: {
    role() {
      return this.$store.state.role;
    },
    icon() {
      return this.$store.state.icon;
    },
  },
  watch: {
    icon: function () {
      this.init();
    },
  },
  methods: {
    //初始化
    init() {
      this.getToken(getmyInfo, {}, (res) => {
        this.list = res.data;
        this.membershipApply =
          res.data.membershipApply && res.data.membershipApply.type;
        // console.log("获取的验证是", this.membershipApply);
        this.applystatus =
          res.data.membershipApply && res.data.membershipApply.status;
        // console.log("获取的状态是", this.applystatus);
        if (res.data.icon) {
          this.imageUrl = res.data.icon;
        } else {
          this.imageUrl = require("../../assets/mine/touxiang.png");
        }
        // this.imageUrl = (res.data || {}).icon || require("../../assets/mine/touxiang.png")
        if (res.data.photo) {
          this.resUrl = res.data.photo;
          //  console.log(this.resUrl)
        } else {
          this.resUrl = require("../../assets/mine/touxiang.jpg");
        }
      });
      this.getToken(checkExpertAppliedApi, {}, (res) => {
        this.isexpert = res.data.status;
        // console.log(this.isexpert)
        this.expertisExist = res.data.isExist;
      });
    },
    //跟换头像
    getUrl(data) {
      console.log("更换头衔", data);
      this.imageUrl = data;
      // console.log(getupdateInfo)
      this.getToken(getupdateInfo, { icon: this.imageUrl }, () => {
        localStorage.setItem("icon", this.imageUrl);
        this.$store.commit("changeIcon", { icon: this.imageUrl });
        this.init();
      });
      // this.getToken(getupdateInfo, { "icon": this.imageUrl }, () => {
      //   // console.log(this.imageUrl)
      //   localStorage.setItem("icon",this.imageUrl );
      //   this.$store.commit("changeIcon", {'icon':this.imageUrl})
      //   this.init();
      // });
    },
    //切换证书头像
    imgfile() {},
    //查看会员权益
    watchbenefits() {
      this.benefitsshow = true;
    },
    benefitscancel() {
      // console.log('当前会员权益是：',this.applytype)
      this.benefitsshow = false;
    },
    benefitsok() {
      this.benefitsshow = false;
    },
    //普通会员申请
    applyper() {
      if (this.list.idCardNum) {
        if (this.applystatus==0) {
          this.$message.error("已有申请在审核中，不能重复操作");
        } else {
          this.applyboxshow = true;
          this.applytype = 1;
        }
      } else {
        this.$message.error("您还未实名认证");
      }
    },
    //vip会员申请
    applyvip() {
      if (this.list.idCardNum) {
        if (this.applystatus==0) {
          this.$message.error("已有申请在审核中，不能重复操作");
        } else {
          this.applyboxshow = true;
          this.applytype = 2;
        }
      } else {
        this.$message.error("您还未实名认证");
      }
    },
    //提交会员申请
    applyok() {
      this.reason = this.info.trim();
      if (this.applytype == 1) {
        if (this.reason) {
          this.getToken(
            getcommitMembershipApplyApi,
            {
              reason: this.reason,
              type: 1,
              authentation: this.list.authentation,
            },
            (res) => {
              if (res.code == 200) {
                this.$message.success("申请成功");
                this.init();
                this.applyboxshow = false;
              }
            }
          );
        } else {
          this.$message.error("请输入申请理由");
        }
        // console.log("提交的原因是：", this.reason);
      } else {
        if (this.reason) {
          this.getToken(
            getcommitMembershipApplyApi,
            {
              reason: this.reason,
              type: 2,
              authentation: this.list.authentation,
            },
            (res) => {
              if (res.code == 200) {
                this.$message.success("申请成功");
                this.init();
                this.applyboxshow = false;
              }
            }
          );
        } else {
          this.$message.error("请输入申请理由");
        }
      }
    },
    //取消会员申请
    applycancel() {
      this.applyboxshow = false;
      this.info = "";
    },
    //绑定电话号码
    bindphone() {
      this.phoneshow = true;
    },
    //获取验证码
    gocade() {
      if (this.phone) {
        this.getToken(checkPhoneApi, { telephone: this.phone }, (res) => {
          if (res.isExist) {
            this.$message.error("手机号码已注册！");
          } else {
            this.getToken(getcodeApi, { telephone: this.phone }, (res) => {
              if (res.code == 200) {
                this.$message.info("验证码已发送，请注意查收！");
                const TIME_COUNT = 60;
                if (!this.timer) {
                  this.count = TIME_COUNT;
                  this.show = false;
                  this.timer = setInterval(() => {
                    if (this.count > 0 && this.count <= TIME_COUNT) {
                      this.count--;
                    } else {
                      this.show = true;
                      clearInterval(this.timer);
                      this.timer = null;
                    }
                  }, 1000);
                }
              }
            });
          }
        });
      } else {
        this.$message.error("请输入正确格式的联系方式");
      }
    },
    //确定联系方式
    phoneOk() {
      if (this.phone) {
        if (this.captcha) {
          this.getToken(
            bingphomeApi,
            { telephone: this.phone, captcha: this.captcha },
            (res) => {
              if (res.code == 200) {
                this.init();
                this.$message.success("绑定成功！");
                this.phoneshow = false;
                this.$refs.form.form.resetFields();
              }
            }
          );
        } else {
          this.$message.error("验证码不能为空");
        }
      } else {
        this.$message.error("联系方式不能为空");
      }
    },
    //取消
    phonecancel() {
      this.$refs.form.form.resetFields();
      this.phoneshow = false;
      this.phone = "";
      this.captcha = "";
    },
    //联系地址按钮
    changeadd() {
      this.addressshow = true;
    },
    //修改联系地址
    changeAddress(data) {
      this.province = data[0];
      this.city = data[1];
      this.district = data.address;
      if (data.address) {
        this.teladdress = data.join("") + data.address;
      } else {
        this.teladdress = data.join("");
      }
    },
    //保存联系地址
    addsure() {
      if (this.teladdress) {
        this.getToken(
          getupdateInfo,
          {
            address: this.teladdress,
            province: this.province,
            city: this.city,
            district: this.district,
          },
          (res) => {
            if (res.code == 200) {
              this.$message.success("修改成功!");
              this.init();
            }
          }
        );
      } else {
        this.$message.error("联系地址不能为空");
      }
      this.addressshow = false;
    },
    //专业按钮
    changemaj() {
      this.majshow = true;
    },
    //修改专业
    majbtn() {
      if (this.major) {
        this.getToken(getupdateInfo, { major: this.major }, (res) => {
          if (res.code == 200) {
            this.$message.success("修改成功!");
            this.init();
          }
        });
      } else {
        this.$message.error("专业不能为空");
      }
      this.major = "";
      this.majshow = false;
    },
    //实名认证
    showModal() {
      if (this.list.idCardNum) {
        this.$message.info("您已实名认证");
      } else {
        this.confirmModal = true;
      }
    },
    //修改实名认证
    handleOk() {
      this.$refs.form.form.validateFields().then((res) => {
        if (res.gender == 1) {
          this.sex = "男";
        } else if (res.gender == 2) {
          this.sex = "女";
        }
        this.getToken(
          getupdateInfo,
          {
            realname: res.name,
            gender: this.sex,
            idCardNum: res.idnum,
            instituteName: res.address,
          },
          (res) => {
            if (res.code == 200) {
              this.confirmModal = false;
              this.$message.success("实名认证成功!");
              this.init();
            }
          }
        );
      });
    },
    // 专家申请
    exbtn() {
      if (this.list.idCardNum) {
        if (this.expertisExist) {
          this.$message.info("已经申请过，请等待审核！");
        } else {
          this.expertshow = true;
        }
      } else {
        this.$message.error("你还未实名认证！");
      }
    },
    //提交专家申请
    expertshowOk() {
      this.$refs.form.form.validateFields().then((res) => {
        // console.log(res)
        let formData = new FormData();
        formData.append("content", res.content);
        formData.append("type", 1);
        formData.append("file", this.fileList[0]);
        this.getToken(expertApplyApi, formData, (data) => {
          this.$message.success(data.message);
          this.init();
          this.expertshow = false;
        });
      });
    },
    //取消专家申请
    expertcancel() {
      this.$refs.form.form.resetFields(["contnet"]);
      this.$refs.form.form.resetFields(["file"]);
      this.fielList = [];
      this.expertshow = false;
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
    },
    beforeUpload(file) {
      const isJpgOrPng =
        file.type === "application/pdf" ||
        file.type === "application/msword" ||
        file.type ===
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
        file.type === "application/vnd.ms-powerpoint" ||
        file.type === "application/vnd.ms-excel" ||
        file.type ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      if (!isJpgOrPng) {
        this.fileList = [];
        return false;
      } else {
        this.fileList = [file];
      }
      return false;
    },
    //取消实名认证
    cancel() {
      this.$refs.form.form.resetFields(["name"]);
      this.$refs.form.form.resetFields(["gender"]);
      this.$refs.form.form.resetFields(["idnum"]);
      this.$refs.form.form.resetFields(["address"]);
      this.confirmModal = false;
    },
    //修改密码按钮
    changepwd() {
      this.pwdshow = true;
    },
    //提交修改密码
    pwdOk() {
      this.$refs.pwdform.form.validateFields().then((res) => {
        // console.log(res)
        if (res.newpwd === res.renewpwd) {
          this.getToken(
            getupdatepwd,
            { pwd: res.pwd, newPwd: this.newpwd },
            (value) => {
              this.init();
              localStorage.setItem("token", value.data.token);
              if (value.code == 200) {
                this.pwdshow = false;
                this.$message.success("密码修改成功!");
                this.$refs.pwdform.form.resetFields(["pwd"]);
                this.$refs.pwdform.form.resetFields(["newpwd"]);
                this.$refs.pwdform.form.resetFields(["renewpwd"]);
              }
            }
          );
        } else {
          this.$message.error("两次密码不一致");
        }
      });
    },
    //取消密码
    pwdcancel() {
      this.$refs.pwdform.form.resetFields(["pwd"]);
      this.$refs.pwdform.form.resetFields(["newpwd"]);
      this.$refs.pwdform.form.resetFields(["renewpwd"]);
      this.pwdshow = false;
    },
    //绑定邮箱按钮
    changeEmail() {
      this.emailshow = true;
    },
    //修改邮箱按钮
    recEmail(data) {
      this.emailshow = true;
      this.fields = { email: data, reemail: data };
    },
    //取消邮箱按钮
    emailcancel() {
      this.emailshow = false;
      this.$refs.emailform.form.resetFields(["email"]);
      this.$refs.emailform.form.resetFields(["reemail"]);
    },
    //修改邮箱按钮
    emailOk() {
      this.$refs.emailform.form.validateFields().then((res) => {
        this.getToken(getupdateInfo, { email: res.email }, (res) => {
          if (res.code == 200) {
            this.init();
            this.$message.success("邮箱绑定成功!");
            this.emailshow = false;
            this.$refs.emailform.form.resetFields(["email"]);
            this.$refs.emailform.form.resetFields(["reemail"]);
          }
        });
      });
    },
    //修改老师职称
    changejobmodel(data) {
      this.jobmenu = data;
      // console.log(this.jobmenu);
    },
    //修改企业职称
    indexSelect(data) {
      this.jobmenu = data;
      // console.log(this.jobmenu);
    },
    //确定职称按钮
    jobbtn() {
      if (this.jobmenu) {
        this.getToken(getupdateInfo, { proTitle: this.jobmenu }, (res) => {
          if (res.code == 200) {
            this.init();
            this.$message.success("修改成功!");
            this.jobshow = false;
          }
        });
      } else {
        this.$message.error("职称不能为空");
      }
      this.addressshow = false;
    },
    //职称按钮
    changejob() {
      this.jobshow = true;
    },
  },
};
</script>
<style>
.basicInfo .ant-upload.ant-upload-select-picture-card {
  width: 100%;
  height: 100%;
  margin: 0;
  text-align: center;
  vertical-align: top;
  border: 0;
  border-radius: 50%;
  cursor: pointer;
}
.basicInfo .ant-upload.ant-upload-select-picture-card > .ant-upload {
  display: table-cell;
  width: 100%;
  height: 100%;
  padding: 0;
  text-align: center;
  vertical-align: middle;
  /* border-radius: 50%; */
}
.basicInfo .eUpload img {
  width: 100%;
  height: 100%;
  /* border-radius: 50%; */
}
.basicInfo .ant-modal-title {
  margin: 0;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 600 !important;
  font-size: 20px !important;
  line-height: 22px;
}
.basicInfo .loadpho {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}
.basicInfo .loadpho img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}
.basicInfo .loadpic {
  width: 100%;
  height: 100%;
}
.basicInfo .loadpic img {
  width: 100%;
  height: 100%;
}
.applymodal .ant-modal-content {
  width: 600px;
}
.applymodal .ant-modal-title {
  margin: 0;
  color: #000;
  font-weight: 600;
  font-size: 20px;
}
.applymodal .ant-modal-close-x {
  font-size: 25px;
}
.applymodal .ant-modal-body {
  margin-top: 20px;
  margin-bottom: 20px;
  font-size: 14px;
  word-wrap: break-word;
  margin-left: 30px;
  margin-right: 30px;
}

.applymodal .applybox p {
  font-size: 16px;
  color: #333;
  margin-bottom: 20px;
  display: flex;
}
.applymodal .applybox p span:nth-child(1) {
  font-weight: 600;
  width: 120px;
  text-align: right;
  display: block;
  margin-right: 20px;
}
.applymodal .applybox p span:nth-child(2) {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
}
.applymodal .applybox p span:nth-child(3) {
  color: #0080ff;
  cursor: pointer;
}
.applymodal .applybox .info {
  display: flex;
}
.applymodal .applybox .info span {
  display: block;
  width: 120px;
  margin-right: 20px;
  font-size: 16px;
  font-weight: 600;
  color: #333;
  text-align: right;
}
.applymodal .applybox .info textarea {
  width: 350px;
  resize: none;
  min-height: 200px;
  overflow: auto;
}
.benefitsmodal .ant-modal-title {
  margin: 0;
  color: #333;
  font-weight: 600;
  font-size: 18px;
}
.benefitsmodal .benefbox {
  font-size: 16px;
  color: #333;
}
.benefitsmodal .ant-modal-body {
  margin-bottom: 20px;
  font-size: 14px;
  word-wrap: break-word;
  margin-left: 30px;
  margin-right: 30px;
}
.benefitsmodal .benefbox li {
  margin-bottom: 10px;
  list-style-type: disc;
}
.benefitsmodal .ant-modal-close-x {
  font-size: 22px;
}
.realmodal .imp {
  color: red;
  padding-left: 10px;
}
.realmodal .ant-modal-body {
  margin-top: 20px;
  margin-bottom: 20px;
  font-size: 14px;
  word-wrap: break-word;
  margin-left: 30px;
  margin-right: 30px;
}
.realmodal .ant-modal-body .formreal {
  /* background:pink; */
  padding-left: 50px;
}
.phonemodal .ant-modal-body {
  margin-top: 20px;
  margin-bottom: 20px;
  font-size: 14px;
  word-wrap: break-word;
  margin-left: 30px;
  margin-right: 30px;
}
.phonemodal .formbox {
  width: 420px;
  margin: 0 auto;
}
.phonemodal .formbox .ant-btn-primary {
  height: 45px;
  width: 420px;
  background-color: #f0cd48;
  border-radius: 3px;
  font-size: 18px;
  border: 0;
  z-index: 555;
}
.phonemodal .formbox .ant-input-affix-wrapper {
  line-height: 45px;
  height: 45px;
}
.phonemodal .formbox .form .iteminp {
  display: flex;
  /* background:pink; */
}
.phonemodal .formbox .form .iteminp .cadeinp {
  width: 150px;
  margin-right: 10px;
  padding-left: -10px;
  /* background:pink; */
}
.phonemodal .formbox .form .iteminp .subbtn {
  width: 110px;
  height: 32px;
  line-height: 32px;
  background: #ffffff;
  border-radius: 3px;
  border: solid 1px #ef9545;
  color: #ef9545;
  outline: none;
}
.phonemodal .formbox .form .iteminp .subbtn .count {
  color: red;
}
.realmodal .ant-modal-body {
  margin-top: 20px;
  padding: 0px;
  font-size: 14px;
  word-wrap: break-word;
}
.expertmodal .ant-modal-body {
  margin-top: 20px;
  padding: 0px;
  font-size: 14px;
  word-wrap: break-word;
  height: 470px;
}
.expertmodal .box {
  padding-left: 30px;
  height: 400px;
}
.expertmodal .box p {
  margin-bottom: 10px;
}
.expertmodal .box table {
  width: 470px;
}
.expertmodal .box table tr td {
  border: 1px solid #afb0b4;
  padding-left: 10px;
}
.expertmodal .box table tr td:first-child {
  background-color: #eaeef7;
}
.expertmodal .box table tr td:nth-child(3) {
  background-color: #eaeef7;
}
.expertmodal .box .under {
  width: 100%;
  margin-top: 30px;
}
.expertmodal .box .under .conbox {
  display: flex;
  width: 100%;
  /* background-color: #f8fafe; */
}
.expertmodal .box .under .conbox .applycon {
  min-height: 200px;
  flex: 1;
  /* width:100%; */
}
.expertmodal .box .under .pro {
  display: flex;
}
.expertmodal .box .under .pro span {
  /* width:70px; */
  margin-right: 30px;
  font-size: 14px;
  color: #333;
}
.expertmodal .box .under .pro .loadbtn {
  width: 83px;
  height: 29px;
  background-color: #fd8d56;
  border-radius: 3px;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
  border: 0;
  outline: none;
}
.pwdmodal .ant-modal-body {
  margin-top: 20px;
  margin-left: 50px;
  font-size: 14px;
  word-wrap: break-word;
}
.emailmodal .ant-modal-body {
  margin-top: 20px;
  margin-left: 50px;
  font-size: 14px;
  word-wrap: break-word;
}
</style>
<style lang="stylus" scoped>
.basicInfo {
  margin-bottom: 100px;

  .title {
    height: 45px;
    line-height: 45px;
    overflow: hidden;
    border-bottom: 1px solid #eff2f2;

    h2 {
      height: 45px;
      line-height: 45px;
      margin-left: 30px;
      font-size: 18px;
      font-weight: bold;
      color: #333333;
    }
  }

  .man {
    width: 100%;
    border-bottom: 1px solid #eff2f2;
    overflow: hidden;

    .tit {
      margin-top: 25px;
      margin-bottom: 30px;

      h2 {
        font-size: 18px;
        height: 20px;
        line-height: 20px;
        margin-left: 36px;
        padding-left: 7px;
        border-left: 3px solid #f0cd48;
      }
    }

    .box {
      display: flex;

      .left {
        flex: 1;

        p {
          color: #333;
          font-size: 14px;
          margin-bottom: 30px;
          margin-left: 80px;
          display: flex;

          span:nth-child(1) {
            color: #333;
            width: 80px;
            font-weight: bold;
            display: block;
            text-align: right;
            margin-right: 45px;
          }

          span:nth-child(2) {
            color: #ef9545;
            cursor: pointer;
          }
        }

        .telp {
          color: #333;
          font-size: 14px;
          margin-bottom: 30px;
          margin-left: 80px;
          display: flex;

          span:nth-child(1) {
            color: #333;
            width: 80px;
            font-weight: bold;
            display: block;
            text-align: right;
            margin-right: 45px;
          }

          span:nth-child(2) {
            color: #333;
            margin-right: 20px;
          }

          span:nth-child(3) {
            color: #ef9545;
            cursor: pointer;
          }
        }

        .ress {
          display: flex;
          align-items: center;
          font-size: 14px;
          padding-left: 80px;
          color: #333;
          margin-bottom: 30px;

          span:nth-child(1) {
            color: #333;
            width: 80px;
            font-weight: bold;
            display: block;
            text-align: right;
            margin-right: 45px;
          }

          span:nth-child(2) {
            color: #333;
            margin-right: 20px;
          }

          span:last-child {
            color: #ef9545;
            cursor: pointer;
          }
        }

        .addinp {
          margin-left: 200px;
          display: flex;
          margin-bottom: 10px;

          .adsbtn {
            width: 40px;
            height: 32px;
            color: #fff;
            background: #f0cd48;
            border-radius: 3px;
            border: 0;
            font-size: 14px;
            cursor: pointer;
            margin-left: 5px;
          }
        }

        .maj {
          height: 35px;
          line-height: 35px;

          span:nth-child(1) {
            color: #333;
            width: 80px;
            font-weight: bold;
            display: block;
            text-align: right;
            margin-right: 45px;
          }

          span:nth-child(2) {
            color: #333;
            margin-right: 20px;
          }

          .majspan {
            color: #ef9545;
            cursor: pointer;
          }

          .majshow {
            border: 1px solid #dfe6e5;
            outline: none;
            margin-left: 20px;
          }

          input::-webkit-input-placeholder {
            padding: 4px 11px;
            color: rgba(0, 0, 0, 0.65);
            font-size: 14px;
          }

          .majbtn {
            width: 40px;
            height: 35px;
            line-height: 35px;
            margin-left: 10px;
            color: #fff;
            background-color: #f0cd48;
            border-radius: 3px;
            border: 0;
            font-size: 14px;
            cursor: pointer;
            outline: none;
          }
        }

        .job {
          display: flex;
          align-items: center;
          color: #333;
          font-size: 14px;
          padding-left: 80px;
          margin-bottom: 30px;

          span:nth-child(1) {
            color: #333;
            width: 80px;
            font-weight: bold;
            display: block;
            text-align: right;
            margin-right: 45px;
          }

          .jobspan {
            color: #333;
            margin-right: 20px;
          }

          .changejob {
            color: #ef9545;
            cursor: pointer;
            margin-left: 20px;
          }

          .mod {
            margin-right: 20px;
            margin-left: 80px;
            display: flex;

            .selbtn {
              width: 110px;
              height: 30px;
            }

            .jobbtn {
              width: 40px;
              height: 32px;
              margin-left: 10px;
              color: #fff;
              background-color: #f0cd48;
              border-radius: 3px;
              border: 0;
              font-size: 14px;
              cursor: pointer;
              outline: none;
            }
          }
        }

        .apply {
          margin-bottom: 20px;

          span:nth-child(2) {
            width: 200px;
          }

          .applyper {
            // width: 111px;
            height: 35px;
            background-color: #f0cd48;
            outline: none;
            border: 0;
            color: #333;
            font-size: 14px;
            margin-right: 30px;
            cursor: pointer;
          }

          .not {
            cursor: auto;
            background: #d5d5d5;
          }

          .applyvip {
            // width: 111px;
            // padding:5px;
            height: 35px;
            background-color: #f0cd48;
            outline: none;
            border: 0;
            color: #333;
            font-size: 14px;
            cursor: pointer;
          }

          .notbox {
            cursor: auto;
            background: #d5d5d5;
          }
        }

        .purview {
          span:nth-child(2) {
            color: #333;
          }
        }

        .pic {
          color: #333;
          width: 700px;
          font-size: 14px;
          margin-bottom: 30px;
          margin-left: 80px;
          display: flex;

          .pictitle {
            color: #333;
            font-weight: bold;
            width: 80px;
            text-align: right;
            margin-right: 45px;
          }

          .loadpic {
            // width:130px;
            // height:130px;
            flex: 1;
          }
        }
      }

      .right {
        display: flex;
        width: 200px;

        .pho {
          width: 100px;
          height: 100px;
          margin-bottom: 50px;

          p {
            margin-bottom: 0px;
            margin-top: 5px;
            color: #ef9545;
            text-align: center;
            width: 100px;
          }
        }
      }
    }
  }

  .real {
    border-bottom: 1px solid #eff2f2;
    overflow: hidden;
    position: relative;

    .tit {
      margin-top: 30px;
      margin-bottom: 30px;

      h2 {
        font-size: 18px;
        height: 20px;
        line-height: 20px;
        margin-left: 36px;
        padding-left: 7px;
        border-left: 3px solid #f0cd48;
      }
    }

    .realbtn {
      width: 111px;
      height: 35px;
      background-color: #f0cd48;
      outline: none;
      border: 0;
      position: absolute;
      right: 48px;
      top: 25px;
      color: #333;
      font-size: 14px;
    }

    .realbox {
      p {
        color: #333;
        font-size: 14px;
        margin-bottom: 30px;
        padding-left: 80px;
        display: flex;

        span {
          color: #333;
          width: 80px;
          font-weight: bold;
          display: block;
          text-align: right;
          margin-right: 45px;
        }
      }
    }
  }

  .expert {
    border-bottom: 1px solid #eff2f2;
    overflow: hidden;
    position: relative;

    .tit {
      margin-top: 30px;
      margin-bottom: 30px;

      h2 {
        font-size: 18px;
        height: 20px;
        line-height: 20px;
        margin-left: 36px;
        padding-left: 7px;
        border-left: 3px solid #f0cd48;
      }
    }

    .box {
      .expertbtn {
        width: 111px;
        height: 35px;
        background-color: #f0cd48;
        outline: none;
        border: 0;
        position: absolute;
        right: 48px;
        top: 25px;
        color: #ffffff;
        font-size: 14px;
      }

      p {
        color: #333;
        font-size: 14px;
        margin-bottom: 30px;
        padding-left: 80px;
        display: flex;

        span:nth-child(1) {
          color: #333;
          width: 80px;
          font-weight: bold;
          display: block;
          text-align: right;
          margin-right: 45px;
        }

        span:nth-child(2) {
          color: #333;
        }
      }
    }
  }

  .safe {
    overflow: hidden;
    position: relative;

    .tit {
      margin-top: 30px;
      margin-bottom: 30px;

      h2 {
        font-size: 18px;
        height: 20px;
        line-height: 20px;
        margin-left: 36px;
        padding-left: 7px;
        border-left: 3px solid #f0cd48;
      }
    }

    .box {
      p {
        color: #333;
        font-size: 14px;
        margin-bottom: 30px;
        padding-left: 80px;
        display: flex;

        span:nth-child(1) {
          color: #333;
          width: 80px;
          font-weight: bold;
          display: block;
          text-align: right;
          margin-right: 45px;
        }

        span:nth-child(2) {
          color: #333;
          margin-right: 20px;
        }

        span:nth-child(3) {
          color: #ef9545;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
